import { memo } from "react";

import { Close, Error as ErrorIcon } from "../../icons";
import "../../styles/_message.scss";

type ErrorProps = {
  closePopup: () => void;
  openForm: () => void;
};

export const Error = memo(({ closePopup, openForm }: ErrorProps) => (
  <div className="accept-button-message-71d72f0d-8486-4d9d-b58c-a5b9facf4701">
    <div className="message__main">
      <button className="message__close" onClick={() => closePopup()}>
        <Close />
      </button>
      <div className="message__icon">
        <ErrorIcon />
      </div>
      <h2 className="message__title">Oops... something went wrong</h2>
      <p className="message__text">Please try again</p>
      <button className="message__action" onClick={() => openForm()}>
        Try again
      </button>
    </div>
  </div>
));
